<template>
  <div class="d-flex">
    <div class="flex-grow-1 text-right" style="flex-basis: 0">
      {{ value.toLocaleString('hun', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
    </div>
    <div v-if="partsWeight" class="flex-grow-1 text-right" style="flex-basis: 0">
      ({{ (value / partsWeight * 100).toLocaleString('hun', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }} %)
    </div>
    <div v-if="efficiency || efficiency === 0" :style="{ 'color' : efficiency > 0 ? 'red' : 'green' }" class="flex-grow-1 text-right" style="flex-basis: 0">
      [{{ efficiency.toLocaleString('hun', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }} %]
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'partsWeight', 'efficiency']
}
</script>

<style scoped>

</style>